import { AppBar, Box, Button, Stack, Toolbar, Typography } from "@mui/material";
import { MobXProviderContext } from "mobx-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import sagresLogo from "assets/images/sagres.png";

function Header() {
    const { authStore } = React.useContext(MobXProviderContext);
    const navigate = useNavigate();

    return (
        <AppBar position="relative" sx={{ backgroundColor: "white", boxShadow: 2 }}>
                <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    
                    {/* Logo e Nome */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box component="img" src={sagresLogo} alt="Sagres" sx={{ width: 160 }} />
                        <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#333" }}>
                            {authStore.usuario?.Nome || 'Visitante'}
                        </Typography>
                    </Box>

                    {/* Botões de Navegação */}
                    <Stack direction="row" spacing={2}>
                        {["Mapa", "Histórico", "Relatórios", "Perfil", "Entregadores"].map((label, index) => (
                            <Button
                                key={index}
                                variant="contained"
                                color="primary"
                                onClick={() => navigate(`/${label.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`)}
                                sx={{
                                    borderRadius: 8,
                                    boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                                    textTransform: "none",
                                    fontWeight: "bold",
                                }}
                            >
                                {label}
                            </Button>
                        ))}
                    </Stack>
                </Toolbar>
        </AppBar>
    );
}

export default Header;
